import React from "react";
import type { FC, PropsWithChildren } from "react";
import styles from "../InputWrapper/InputWrapper.module.css";

type InputWrapperProps = PropsWithChildren<{
  title?: string;
  popupText?: string;
  subTitle?: React.ReactNode;
  icon?: string;
  className?: string;
  style?: React.CSSProperties;
  customStyle?: React.CSSProperties;
  type?: string;
  error?: string;
}>;

const InputWrapper: FC<InputWrapperProps> = ({
  title,
  subTitle,
  icon,
  children,
  className,
  style,
  customStyle,
  popupText,
  type,
  error,
}) => {
  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);

  return (
    <div className={`${styles.input_wrapper} ${className || ""}`} style={style}>
      {title && (
        <h3 className={styles.input_wrapper__heading}>
          {title}
          {icon && (
            <button onClick={() => setShowTooltip((prevVal) => !prevVal)}>
              <svg>
                <use xlinkHref={`/assets/sprite.svg#${icon}`} />
              </svg>
            </button>
          )}
          {popupText && showTooltip && <span>{popupText}</span>}
        </h3>
      )}
      <div className={`${styles.input_wrapper__content} ${className || ""} `}>
        {subTitle && (
          <h4 className={styles.input_wrapper__subheading}>{subTitle}</h4>
        )}
        {/* {type && <h4 className={styles.input_wrapper__type}>Answer Type: {type}</h4>} */}
        <div style={customStyle}>{children}</div>
        {error && <span className={styles.error_message}>{error}</span>}
      </div>
    </div>
  );
};

export default InputWrapper;
